<template>
  <div class="home-box">
    <PageTitle :title="'Project Preview'"></PageTitle>
    <v-row align="center">
      <v-overlay :value="loading" :opacity="1" :color="'#FFFFFF'">
        <v-progress-circular color="#FFB300" indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <div class="col-md-12 home-tabs-body">
        <Step01 :uuid="uuid" v-if="!loading && projectInfo" :form="projectInfo" class="mb-8"></Step01>
        <Step02 :uuid="uuid" class="mb-8" v-if="!loading && projectInfo"></Step02>
        <Step03 :uuid="uuid" v-if="!loading && projectInfo" class="mb-8"></Step03>
        <Step04 :uuid="uuid" v-if="!loading && projectInfo" class="mb-8"></Step04>
        <Step05 :data="projectInfo" v-if="!loading && projectInfo" class="mb-8"></Step05>
        <Step08 :data="projectInfo" v-if="!loading && projectInfo && projectInfo.status !== 'PROCESSING'" class="mb-8"
          @reload="getProjectInfo()"></Step08>
        <Step06 :data="projectInfo" :uuid="uuid" v-if="!loading && projectInfo" class="mb-8"></Step06>
        <Step11 :data="projectInfo" :uuid="uuid" @reload="getProjectInfo()" v-if="!loading && projectInfo" class="mb-8"></Step11>
        <Step09 :data="projectInfo" v-if="!loading && projectInfo && projectInfo.status === 'APPROVED'" class="mb-8">
        </Step09>
        <Step10 :data="projectInfo" :uuid="uuid" @reload="getProjectInfo()"
          v-if="!loading && projectInfo && projectInfo.status === 'APPROVED' && role == 'CLUBS_PERFORMANCE_EVALUATION'"
          class="mb-8">
        </Step10>
        <Step07 @updateApproval="updateApproval()" :data="projectInfo" v-if="!loading && projectInfo" class="mb-8">
        </Step07>
      </div>
    </v-row>
  </div>
</template>

<script>
import Step01 from "@/components/service-projects/view/info/Step01";
import Step02 from "@/components/service-projects/view/info/Step02";
import Step03 from "@/components/service-projects/view/info/Step03";
import Step04 from "@/components/service-projects/view/info/Step04";
import Step05 from "@/components/service-projects/view/info/Step05";
import Step06 from "@/components/service-projects/view/info/Step06";
import Step07 from "@/components/service-projects/view/info/Step07";
import Step08 from "@/components/service-projects/view/info/Step08";
import Step09 from "@/components/service-projects/view/info/Step09";
import Step10 from "@/components/service-projects/view/info/Step10";
import Step11 from "@/components/service-projects/view/info/Step11";
import PageTitle from "@/components/shared/PageTitle";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import { ProjectService } from "../../services/project-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "Projects",
  components: {
    Step01,
    Step02,
    Step03,
    Step04,
    Step05,
    Step06,
    Step07,
    Step08,
    Step09,
    Step10,
    Step11,
    PageTitle,
  },
  data: function () {
    return {
      uuid: this.$route.params.uuid,
      projectInfo: [],
      loading: false,
      approvalRole: null,
      role: localStorage.getItem('role') || null
    };
  },
  computed: {
    ...mapGetters({
      profile: "profile",
    }),
  },

  mounted() {
    this.uuid = this.$route.params.uuid;
    this.getProjectInfo();
    this.$store.dispatch("auth/getProfile");
    this.checkCanApproval();
  },

  methods: {
    getProjectInfo() {
      if (this.uuid !== null) {
        this.loading = true;
        ProjectService.getProjectInfo(this.uuid)
          .then((response) => {
            this.loading = false;
            this.projectInfo = [];
            if (response.data.data) {
              this.projectInfo = response.data.data;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.projectInfo = [];
            if (error.response) {
              let data = error.response.data;
              let errorOutput = checkError.errorFormatting(data);
              this.errors = errorOutput;
            }
          });
      }
    },

    updateApproval() {
      this.$route.push();
    },

    checkCanApproval() {
      if (this.uuid !== null) {
        this.loading = true;
        ProjectService.checkCanApproval(this.uuid)
          .then((response) => {
            this.loading = false;
            this.approvalRole = null;
            if (response.data?.data?.review_role) {
              this.approvalRole = response.data?.data?.review_role;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.approvalRole = null;
            if (error.response) {
              let data = error.response.data;
              let errorOutput = checkError.errorFormatting(data);
              this.errors = errorOutput;
            }
          });
      }
    },
  },

  watch: {},
};
</script>
